import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReduxBlockUi from 'react-block-ui/redux';
import { Row, Col, Glyphicon, PanelGroup, Panel, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import {
	fetchWorkshop, WORKSHOP_FETCH_REQUEST, WORKSHOP_FETCH_SUCCESS, WORKSHOP_FETCH_FAILURE,
} from '../../dashboard/common/actions';
import { resetBooking } from '../../dashboard/booking/actions';
import analyticsTracker, { AnalyticsPlatforms } from '../../common/services/analyticsTracker';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import CenterDetailsLink from '../../common/components/CenterDetailsLink';
import MapComponent from '../../common/components/MapComponent';
import ui from '../../common/services/ui';
import { getActiveLanguage } from '../../languages/reducer';

class WorkshopDetails extends Component {
	constructor(props) {
		super(props);
		this.handleBookWorkshop = this.handleBookWorkshop.bind(this);
	}

	componentDidMount() {
		this.props.fetchWorkshop(Number(this.props.centerId), Number(this.props.workshopId));

		// track view with workshop already loaded from the list
		if (this.props.workshop && this.props.center) {
			this.trackView(this.props.workshop, this.props.center);
		}

		window.scrollTo(0, 0);
	}

	componentWillReceiveProps(nextProps) {
		// track view on refresh after all required entities are loaded
		if ((!this.props.workshop || !this.props.center) && nextProps.workshop && nextProps.center) {
			this.trackView(nextProps.workshop, nextProps.center);
		}
	}

	trackView(workshop, center) {
		analyticsTracker.trackEvent('view_item', {
			items: [
				{
					item_id: `Workshop_${workshop.id}`,
					item_name: workshop.name,
					item_brand: center.name,
					item_category: 'Workshop'
				}
			]

		}, AnalyticsPlatforms.GoogleAnalytics);
	}

	handleBookWorkshop() {
		const { isAuthenticated, match, history, centerId, workshopId, resetBooking } = this.props;

		if (isAuthenticated) {
			history.push(`/workshop/booking/${centerId}/${workshopId}/child?reset=true`);
		} else {
			resetBooking();
			history.push(match.url + '/sessions');
		}
	}

	render() {
		const { centerId, workshop, center,
			currentCurrency, franchisorCurrency, enableCurrencyConversion, t } = this.props;

		const fullWeekOrDayConversionLink = workshop && ui.getCurrencyConversionLink(enableCurrencyConversion, currentCurrency, franchisorCurrency, workshop.fullWeekPriceAmount || workshop.fullDayPriceAmount);
		const fullDayConversionLink = workshop && ui.getCurrencyConversionLink(enableCurrencyConversion, currentCurrency, franchisorCurrency, workshop.fullDayPriceAmount);
		const halfDayConversionLink = workshop && ui.getCurrencyConversionLink(enableCurrencyConversion, currentCurrency, franchisorCurrency, workshop.halfDayPriceAmount);

		return <div className='timetable-wrapper'>
			<ReduxBlockUi block={WORKSHOP_FETCH_REQUEST} unblock={[WORKSHOP_FETCH_SUCCESS, WORKSHOP_FETCH_FAILURE]}>
				<Row>
					<Col md={12}>
						<Link to={`/public/workshops?centerId=${centerId}`} className='btn btn-back btn-block-xxs'><FontAwesome name='arrow-circle-left' /> {t('FO_ProgramDetails_Back')}</Link>
					</Col>
				</Row>
				<Row style={{ marginTop: '30px' }}>
					<Col md={8}>{workshop && <div className='booking-options-container' style={{ width: '100%', margin: 0, marginBottom: 20 }}>
						<h3>{workshop.name}</h3>
						<p>
							<CenterDetailsLink center={center} className='visible-xs' style={{ float: 'left' }} />
							{center && <span className='hidden-xs' style={{ float: 'left' }}><Glyphicon glyph='map-marker' /> {center.name}</span>}
							<span className='clearfix' />
						</p>
						<p>
							<Glyphicon glyph='calendar' /> {`${moment(workshop.startDate).format('LL')} - ${moment(workshop.endDate).format('LL')}`}
							{workshop.weeks.sort((a, b) => moment(a.startDate) - moment(b.startDate)).map(week => <div key={`week${week.id}`} style={{ marginLeft: 20 }}>
								<b>{week.name}</b> <span className='text-muted'>{`${moment(week.startDate).format('ll, ddd')} - ${moment(week.endDate).format('ll, ddd')}`}</span>
							</div>)}
						</p>
						{<div dangerouslySetInnerHTML={{ __html: workshop.description }} style={{ marginTop: '20px', marginBottom: '20px' }} />}
						<h4 className='hidden-xs'>{t('FO_Booking_CenterLocation')}</h4>
						{center && <div className='hidden-xs'>
							{center.latitude && center.longitude && <MapComponent
								latitude={center.latitude}
								longitude={center.longitude}
								isSingleMarker
							/>}
							<h5>{center.name}</h5>
							{center.address && <p><Glyphicon glyph='map-marker' /> {center.address}</p>}
							<p>{center.addressDescription}</p>
							{center.phoneNumber && <p><Glyphicon glyph='earphone' /> {center.phoneNumber}</p>}
							{center.email && <p><Glyphicon glyph='envelope' /> {center.email}</p>}
							{center.additionalInfo && <p> <Glyphicon glyph='info-sign' /> <span dangerouslySetInnerHTML={{ __html: center.additionalInfo }} /></p>}
						</div>}
					</div>}
					</Col>
					<Col md={4}>
						{workshop && <div className='booking-options-container' style={{ width: '100%', margin: 0, marginBottom: 20 }}>
							<h3>{t('FO_Booking_BookingOptions_Title')}</h3>
							<PanelGroup>
								<Panel key='fullWeek' className='booking-option'>
									<Panel.Body>
										<div className='payment-type'>{t('FO_WorkshopBookingOption_FullWeek')}</div>
										<div className='price'>{workshop.fullWeekPrice || t('FO_WorkshopBookingOption_FullWeek_PricePerDay', { price: workshop.fullDayPrice })}
											{fullWeekOrDayConversionLink &&
												<a href={fullWeekOrDayConversionLink} target='_blank' className='currency-conversion' style={{ float: 'right' }}>{t('FO_Common_ConvertToCurrency', { currency: currentCurrency })}</a>}
										</div>
									</Panel.Body>
								</Panel>
								{workshop.allowIndividualDays && <Panel key='fullDay' className='booking-option'>
									<Panel.Body>
										<div className='payment-type'>{t('FO_WorkshopBookingOption_SingleDay')}</div>
										<div className='price'>{workshop.fullDayPrice}
											{fullDayConversionLink &&
												<a href={fullDayConversionLink} target='_blank' className='currency-conversion' style={{ float: 'right' }}>{t('FO_Common_ConvertToCurrency', { currency: currentCurrency })}</a>}
										</div>
									</Panel.Body>
								</Panel>}
								{workshop.allowHalfDaySessions && <Panel key='halfDay' className='booking-option'>
									<Panel.Body>
										<div className='payment-type'>{t('FO_WorkshopBookingOption_HalfDay')}</div>
										<div className='price'>{workshop.halfDayPrice}
											{halfDayConversionLink &&
												<a href={halfDayConversionLink} target='_blank' className='currency-conversion' style={{ float: 'right' }}>{t('FO_Common_ConvertToCurrency', { currency: currentCurrency })}</a>}
										</div>
									</Panel.Body>
								</Panel>}
							</PanelGroup>
							{workshop.allowBooking ? <Button className='btn-block btn btn-primary' onClick={() => this.handleBookWorkshop()}>
								{t('FO_Booking_BookingOptions_Select')} <i className='fa fa-arrow-circle-right' />
							</Button> : <Alert bsStyle='warning'>{t('FO_Workshop_BookingNotStarted')}</Alert>}
						</div>}
					</Col>
				</Row>

			</ReduxBlockUi>
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const centerId = Number(ownProps.match.params.centerId);
	const workshopId = Number(ownProps.match.params.workshopId);

	const { entities: { centers, workshops }, configuration: { franchisor }, auth: { isAuthenticated } } = state;
	const activeLanguage = getActiveLanguage(state.configuration.language);

	return {
		isAuthenticated,
		centerId,
		workshopId,
		center: centers[centerId],
		workshop: workshops[workshopId],
		currentCurrency: activeLanguage && activeLanguage.currencyCode,
		franchisorCurrency: franchisor && franchisor.currency,
		enableCurrencyConversion: franchisor && franchisor.enableCurrencyConversion
	};
};

export default connect(mapStateToProps, {
	fetchWorkshop,
	resetBooking
})(withNamespaces()(WorkshopDetails));